
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/corporatiu/avis-legal/privacitat/publicitat/es",
      function () {
        return require("private-next-pages/corporatiu/avis-legal/privacitat/publicitat/es/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/corporatiu/avis-legal/privacitat/publicitat/es"])
      });
    }
  